import React, { createContext, useContext, useState } from "react";
import { recordFieldMapping, prostateCancerFieldMapping, mentalHealthFieldMapping } from "../../../utils/constants";
import { getRecords, getProstateCancerRecords, getRangeFieldMaxMinValues, getProstateRangeFieldMaxMinValues } from "../../../utils/services";

const HomeTabContext = createContext(null);

export const HomeTabProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <HomeTabContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </HomeTabContext.Provider>
  );
};

export const useHomeTab = () => useContext(HomeTabContext);

export const HOME_TABS = ["Opioid", "Prostate Cancer", "Mental Health"];

export const TAB_DISEASE_TYPES = ["opioid", "prostate_cancer", "mental_health"];

// Mental Health is not wired up to a backend yet — keep its tab visible but disabled until it is.
export const HOME_TABS_DISABLED = [false, false, true];

// Single source of truth for per-tab config, shared by the History page and the History filter bar.
export const TAB_FIELD_MAPPINGS = [recordFieldMapping, prostateCancerFieldMapping, mentalHealthFieldMapping];

export const TAB_RECORD_FETCHERS = [getRecords, getProstateCancerRecords, null];

export const TAB_MAXMIN_FETCHERS = [getRangeFieldMaxMinValues, getProstateRangeFieldMaxMinValues, null];
